import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router";
import subIcon from "../../assets/images/fake/subCatIcon.png";
import { FaAngleLeft } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setShowAllNum } from "../../Redux/Actions";

const SubCategoryItem = (props) => {
  const [categoryNum, setCategoryNum] = useState();
  const [showAll, setShowAll] = useState(false);
  const dispatch = useDispatch();
  const showAllRef = useRef();
  useEffect(() => {
    // if (props.showAll) {
    setShowAll(props.showAll);
    //   let showAllBtn = document.querySelector(".showAllBtn");
    //   console.log("showAllBtn", showAllBtn);
    //   if (showAllBtn) {
    //     showAllBtn.click();
    //   }
    //   // showProduct(props.id, props.subCategory, showAllBtn);
    //   // alert(1);
    // }
    setCategoryNum(props.categoryNum);
  }, [props.categoryNum, props.showAll]);

  const showProduct = (id, sub, e) => {
    if (categoryNum >= 0) {
      // localStorage.setItem("categoryNum", categoryNum);
      dispatch(setShowAllNum(categoryNum));
    } else {
      // localStorage.removeItem("categoryNum");
      dispatch(setShowAllNum(null));
    }
    props.history.replace({
      pathname: `/products`,
      state: { categoryId: id },
    });
    if (sub) {
      props.showThirdCategory(sub);
    }
    if (props.isThirdCat) {
      let all = document.querySelectorAll(".thirdSubs");
      all.forEach((item) => item.classList.remove("active"));
      if (e.target.tagName === "IMG") {
        e.target.parentElement.classList.add("active");
      } else {
        e.target.classList.add("active");
      }
    } else {
      let all = document.querySelectorAll(".subs");
      all.forEach((item) => item.classList.remove("active"));
      if (e.target.tagName === "IMG") {
        e.target.parentElement.classList.add("active");
      } else {
        e.target.classList.add("active");
      }
    }
  };

  return (
    <div className="subCategoryItems">
      <div
        className={`subs ${props.isThirdCat ? "thirdSubs" : " "} ${showAll ? "active showAllBtn" : ""}`}
        onClick={(e) => showProduct(props.id, props.subCategory, e)}
        ref={showAllRef}
      >
        <img className="subCatIcon" src={props.image} />
        {props.categoryTitle}
      </div>
    </div>
  );
};

export default React.memo(withRouter(SubCategoryItem));
